<ng-container *ngIf="tabs.length > 0">
  <mat-tab-group
    #tabGroup
    class="decorator-tabs"
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    [selectedIndex]="selectedIndex"
    (selectedTabChange)="selectedTabChange($event)"
  >
    <mat-tab
      *ngFor="let tab of tabs; trackBy: tabTrackByFn; index as i"
      [label]="tab.label"
      [disabled]="tab.disabled"
    >
      <ng-template mat-tab-label>
        <span
          *ngIf="tab.label"
          acaTabsHoverAnimation
          [tabGroup]="tabGroup"
          [tabIndex]="i"
          [id]="i"
          >{{ tab.label | translate }}</span
        >
      </ng-template>
    </mat-tab>
  </mat-tab-group>
  <div class="tc-panel-button-wrapper" *ngIf="isEditable">
    <button
      id="tc-panel-btn"
      mat-button
      [matMenuTriggerFor]="sidebarMenu"
      class="tc-panel-btn"
      [title]="
        ((sidebarMode$ | async) === sidebarModeConstants.WIDE_SIDEBAR
          ? 'ADF_VIEWER.ACTIONS.TOGGLE_INLINE_TRACKCHANGE_MODE_TOOLTIP'
          : 'ADF_VIEWER.ACTIONS.TOGGLE_SIDEBAR_TRACKCHANGE_MODE_TOOLTIP'
        ) | translate
      "
    >
      <mat-icon class="tc-panel-icon">visibility</mat-icon>
      <span class="tc-panel-text">{{
        ((sidebarMode$ | async) === sidebarModeConstants.INLINE
          ? 'ADF_VIEWER.ACTIONS.TC_PANEL_BTN_INLINE_LABEL'
          : 'ADF_VIEWER.ACTIONS.TC_PANEL_BTN_WIDE_SIDEBAR_LABEL'
        ) | translate
      }}</span>
    </button>
    <mat-menu #sidebarMenu="matMenu" class="tc-panel-menu">
      <button
        mat-menu-item
        (click)="
          onSidebarModeClick($event);
          setSidebarMode(sidebarModeConstants.WIDE_SIDEBAR)
        "
      >
        <span>{{
          'ADF_VIEWER.ACTIONS.TC_PANEL_BTN_WIDE_SIDEBAR_LABEL' | translate
        }}</span>
      </button>
      <button
        mat-menu-item
        (click)="
          onSidebarModeClick($event);
          setSidebarMode(sidebarModeConstants.INLINE)
        "
      >
        <span>{{
          'ADF_VIEWER.ACTIONS.TC_PANEL_BTN_INLINE_LABEL' | translate
        }}</span>
      </button>
    </mat-menu>
  </div>
  <div
    #ckContainer
    [ngClass]="{
      'copy-icon-disable': !(isCopyEnable$ | async),
      'sidebar-mode-wide': (sidebarMode$ | async) === 'Wide sidebar'
    }"
  >
    <wk-ckeditor
      *ngIf="isLoaded$ | async"
      class="editor-instance"
      id="{{ rhpEditorId }}"
      [config]="toolbarConfig"
      [editor]="editor"
      (ready)="onReady()"
      [disabled]="!(isEditable$ | async)"
      (change)="isEditable ? onChange() : ''"
      (mouseleave)="onMouseLeave()"
      (save)="saveDocument()"
      (insertlink)="onInsertLink($event)"
      (openContextMenu)="openContextMenu($event)"
      (routeToLink)="routeToLink($event)"
      (commentStatusThreadId)="saveDocument()"
      (pasteExternalConfirmationRequired)="
        onExternalPasteConfirmationRequired($event)
      "
    >
    </wk-ckeditor>
  </div>
  <wk-tc-cross-links-panel></wk-tc-cross-links-panel>
  <wk-context-menu-editor
    *ngIf="loadContextMenuComponent"
    [contextMenuObject]="contextMenuObject"
  ></wk-context-menu-editor>
</ng-container>
